import { cn } from "~/common/cn"
import { balanceText } from "~/common/text-utils"
import { AppText } from "~/ui/app-text"
import { UserAvatar } from "~/ui/user-avatar"

interface HostPillProps {
  member: {
    avatarUrl?: string | null
    displayOrUsername?: string | null
    verifiedAccount?: boolean | null
  }
  variant?: "horizontal" | "stacked"
}

export const HostPill = ({ member, variant = "horizontal" }: HostPillProps) => {
  const charLimit = variant === "stacked" ? 20 : 12
  const [firstLine, secondLine] = balanceText(member.displayOrUsername ?? "", charLimit)

  if (variant === "stacked") {
    return (
      <div className={cn("flex shrink-0 flex-col items-center gap-2 p-1")}>
        <UserAvatar
          avatarUrl={member.avatarUrl}
          displayName={member.displayOrUsername || ""}
          verifiedAccount={member.verifiedAccount ?? undefined}
          size={"md"}
          verifiedBadgeSize={"md"}
          imgClassName="border-0"
          className="border-0"
        />
        <AppText
          variant="hairline-2"
          className={cn(
            "line-clamp-2 max-w-[100px] text-center font-bold normal-case leading-[16px] text-base-white"
          )}
        >
          {secondLine ? (
            <>
              {firstLine}
              <br />
              {secondLine}
            </>
          ) : (
            firstLine
          )}
        </AppText>
      </div>
    )
  }

  return (
    <div
      className={cn(
        "flex shrink-0 flex-row items-center rounded-full bg-opacity-black px-2 py-1 md:m-1"
      )}
    >
      <UserAvatar
        avatarUrl={member.avatarUrl}
        displayName={member.displayOrUsername || ""}
        verifiedAccount={member.verifiedAccount ?? undefined}
        size={"shareCard"}
        verifiedBadgeSize={"sm"}
      />
      <div className={cn("px-2 py-1")}>
        <AppText
          variant="body2-medium"
          className={cn("line-clamp-2 w-full text-left text-base-white")}
        >
          {secondLine ? (
            <>
              {firstLine}
              <br />
              {secondLine}
            </>
          ) : (
            firstLine
          )}
        </AppText>
      </div>
    </div>
  )
}
